<template>
  <div class="app-container">
    <!-- <div class="save">
      <el-button type="primary" @click="toSave" :loading="loading" round
        >保存</el-button
      >
    </div> -->
    <el-form ref="form" label-width="80px" class="form">
      <fieldset>
        <legend>采购</legend>
        <div class="form-item">
          <label>立账方式</label>
          <el-select
            v-model="data.WayId"
            @change="changeAccount"
            :disabled="loading"
          >
            <el-option :value="0" label="进货单立账"></el-option>
            <el-option :value="1" label="采购发票立账"></el-option>
          </el-select>
        </div>
        <el-radio-group
          v-model="data.ProcessType"
          class="radio"
          v-if="data.WayId === 0"
          @change="changeProcessType"
          :disabled="loading"
        >
          <el-row class="radio-item">
            <el-radio v-model="data.ProcessType" :label="0"
              >业务与仓库分开管理</el-radio
            >
          </el-row>
          <el-row class="radio-item">
            <el-radio v-model="data.ProcessType" :label="1"
              >业务与仓库合并管理</el-radio
            >
          </el-row>
        </el-radio-group>
      </fieldset>
    </el-form>
    <fieldset class="remark" v-if="data.WayId === 0 && data.ProcessType === 0">
      <legend>流程说明</legend>
      <label>采购订单-业务仓库分开管理：</label>
      <div>
        <label>采购订单：</label>采购员与供应商确定交易条款，签订采购合同
      </div>
      <div>
        <label>进货单：</label
        >采购部根据实际入库货品清单与供应商对账后,确定结算数量,结算单价和金额
      </div>
      <div><label>采购入库单：</label>仓管员收到商品,进行合格品入库</div>
      <div><label>付款：</label>财务根据进货单的结算数量和金额进行付款结算</div>
    </fieldset>
    <fieldset class="remark" v-if="data.WayId === 0 && data.ProcessType === 1">
      <legend>流程说明</legend>
      <label>采购订单-业务仓库合并管理：</label>
      <div>
        <label>采购订单：</label>采购员与供应商确定交易条款，签订采购合同
      </div>
      <div><label>进货单：</label>仓管员负责收货</div>
      <div><label>付款：</label>财务按照进货数量和金额进行付款结算</div>
    </fieldset>
    <fieldset class="remark" v-if="data.WayId == 1">
      <legend>流程说明</legend>
      <label>采购订单-业务仓库分开管理：</label>
      <div>
        <label>采购订单：</label>采购员与供应商确定交易条款，签订采购合同
      </div>
      <div><label>采购入库单：</label>仓管员收到货品,进行合格品入库</div>
      <div><label>进货单：</label>采购部根据实际入库货品清单,补填进货通知</div>
      <div>
        <label>采购发票：</label>财务收到采购发票或供应商发出的其他结算票据
      </div>
      <div>
        <label>付款：</label>财务根据采购发票的结算数量和金额进行付款结算
      </div>
    </fieldset>
  </div>
</template>
<script>
// import curdMixins from "@/mixins/curd";

export default {
  name: "flow",
  mixins: [],
  data() {
    return {
      api: require("@/api/pu/purchaseProcess").default,
      loading: false,
      data: {
        PurchaseProcessId: 0,
        WayId: 1,
        ProcessType: 0,
      },
    };
  },
  beforeMount() {
     this.api.info(this.$commonJs.userId()).then((res) => {
      if (res.Code === 0) {
        this.data = res.Data;
      }
    });
  },
  methods: {
    changeAccount(data) {
      this.loading = true;
      this.api.save(this.data).then((res) => {
        this.loading = false;
        if (res.Code !== 0) {
          this.loading = true;
          return this.$message.error(res.Msg);
        }
        if (res.Code === 0) {
          this.$message.success(res.Msg);
          this.api.info(this.$commonJs.userId()).then((res) => {
            if (res.Code === 0) {
              this.data = res.Data;
            }
          });
        }
      });
    },
    changeProcessType(data) {
      this.loading = true;
      this.api.save(this.data).then((res) => {
        this.loading = false;
        if (res.Code !== 0) {
          return this.$message.error(res.Msg);
        }

        if (res.Code === 0) {
          this.$message.success(res.Msg);
          this.api.info(this.$commonJs.userId()).then((res) => {
            if (res.Code === 0) {
              this.data = res.Data;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.save {
  padding-bottom: 20px;
}
.remark {
  display: inline-block;
  font-size: 14px;
  width: 350px;
}
fieldset {
  padding-left: 15px;
  height: 220px;
  border: 1px solid #999;
  vertical-align: top;
}

legend {
  padding: 0 5px;
  font-size: 14px;
}

.form {
  display: inline-block;
  width: 290px;

  label {
    margin-right: 5px;
    color: #333 !important;
    font-size: 13px;
    font-weight: 520;
  }

  .form-item {
    margin: 10px 0;
  }

  .ProcessType {
    .ProcessType-item {
      padding: 10px 0;
    }
  }
  .radio {
    .radio-item {
      padding: 10px 0;
    }
  }
}
</style>
